export const TIMETABLE = [3, 7, 7, 7, 5, 5, 5, 3];
export const ROUNDS = 8;
export const MAX_INFO = 52;
export const NEGATIVE_MULTIPLIER = 5;
export const NEGATIVE_NUMBER = 5;
export const ROUNDCONFIG = [
    { diceSummary: true, trainerSummary: true },
    { diceSummary: false, trainerSummary: false },
    { diceSummary: false, trainerSummary: false },
    { diceSummary: true, trainerSummary: true },
    { diceSummary: false, trainerSummary: false },
    { diceSummary: true, trainerSummary: true },
    { diceSummary: false, trainerSummary: false },
    { diceSummary: true, trainerSummary: false },
];
